import { BriefResponseDto } from '@/app/common/general-types/briefs.dto';
import { environment } from '@/environments/environment';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { form } from '@angular/forms/signals';

@Injectable({
  providedIn: 'root',
})
export class EditPostRequirementsService {

  /** Editing Sections */
  editingPostRequirements = signal<boolean>(false);
  editInProgress = signal<boolean>(false);
  focussedBriefId = signal<string | undefined>(undefined);
  /** Editing Sections - END */

  /** Post Requirements Values */
  postRequirementsModel = signal({
    suggestedCaption: '',
    suggestedHastags: '',
    callToActionLink: '',
  });
  postRequirementsForm = form(this.postRequirementsModel);
  /** Post Requirements Values - END */

  /** Services */
  http = inject(HttpClient);
  /** Services - END */

  savePostRequirements(payload: {
    suggestedCaption: string;
    suggestedHastags: string;
    callToActionLink: string;
  }) {
    const update_brief_post_requirements_url = `${environment.shout_api.url}/briefs/edit-brief/post-requirements/${this.focussedBriefId()}`;
    return this.http.post<BriefResponseDto>(update_brief_post_requirements_url, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }
}
